// @ts-nocheck
import * as types from 'appRedux/actions/variation_register';
import copy from 'utils/cloneObj';

const notesModal = {
  show: false,
  message: '',
  taskId: null,
  noteId: null,
  list: [],
  mode: 'add',
  attachment: null,
};

const claimStatus = [
  { label: 'All', value: 'all', checked: false },
  { label: 'Pending', value: 1, checked: false },
  { label: 'Approved', value: 2, checked: false },
  { label: 'Partial Approved', value: 3, checked: false },
  { label: 'Non Claimable', value: 4, checked: false },
  { label: 'Rejected', value: 5, checked: false },
];
const initialState = {
  notesModal,
  claimStatus,
  loader: false,
  selectedTaskId: null,
  variationTasks: [],
  expandedRow: {
    tasks: [],
  },
  pagination: {
    totalPages: null,
    total: null,
    perPage: 15,
    pageNumber: 1,
    // links: null,
  },
  updatedTasks: [],
  addNoteSuccess: false,
  updateNoteSuccess: false,
  deleteNoteSuccess: false,
  postVariationTasksSuccess: false,
  updateClaimStatusSuccess: false,
};

function variationRegisterReducer(state = initialState, action = {}) {
  switch (action.type) {
    case types.GET_VARIATION_TASKS_REQUEST:
      return {
        ...state,
        loader: true,
      };

    case types.GET_VARIATION_TASKS_SUCCESS:
      return {
        ...state,
        variationTasks: action.payload.data,
        pagination: {
          ...state.pagination,
          totalPages: action.payload.total_pages
            ? action.payload.total_pages
            : null,
          perPage: action.payload.per_page ? action.payload.per_page : 5,
          total: action.payload.total ? action.payload.total : null,
          pageNumber: action.payload.current_page
            ? action.payload.current_page
            : 1,
          // links: action.payload.links,
        },
        loader: false,
      };

    case types.POST_VARIATION_TASKS_REQUEST:
      return {
        ...state,
        postVariationTasksSuccess: false,
      };

    case types.POST_VARIATION_TASKS_SUCCESS:
      return {
        ...state,
        postVariationTasksSuccess: true,
      };

    case types.EXPAND_ROW_VARIATION_REGISTER:
      return expandRow(state, action);

    case types.UPDATE_VARIATION_REGISTER_PAGE:
      return {
        ...state,
        pagination: {
          ...state.pagination,
          pageNumber: action.payload,
        },
      };

    case types.UPDATE_VARIATION_REGISTER_PER_PAGE:
      return updatePerPage(state, action);

    case types.UPDATE_VARIATION_TASK:
      return updateVariationTask(state, action);

    case types.UPDATE_CLAIM_STATUS:
      return updateClaimStatus(state, action);

    case types.RESET_UPDATE_CLAIM_STATUS_SUCCESS:
      return {
        ...state,
        updateClaimStatusSuccess: false,
      };

    case types.OPEN_VARIATION_REGISTER_MODAL:
      return {
        ...state,
        notesModal: {
          ...state.notesModal,
          show: true,
          taskId: action.payload.taskId,
          list: action.payload.notes,
        },
      };

    case types.CLOSE_VARIATION_REGISTER_MODAL:
      return {
        ...state,
        notesModal,
      };

    case types.UPDATE_VARIATION_REGISTER_NOTES_MSG:
      return {
        ...state,
        notesModal: {
          ...state.notesModal,
          message: action.payload.message,
        },
      };

    case types.UPDATE_VARIATION_REGISTER_NOTES_ATTACHMENT:
      return {
        ...state,
        notesModal: {
          ...state.notesModal,
          attachment: action.payload.attachment,
        },
      };

    case types.ADD_VARIATION_REGISTER_NOTE_REQUEST:
      return {
        ...state,
        addNoteSuccess: false,
      };

    case types.ADD_VARIATION_REGISTER_NOTE_SUCCESS:
      return {
        ...state,
        addNoteSuccess: true,
        notesModal,
      };

    case types.EDIT_VARIATION_REGISTER_NOTE:
      return {
        ...state,
        notesModal: {
          show: true,
          message: action.payload.message,
          taskId: null,
          noteId: action.payload.noteId,
          list: [],
          mode: 'edit',
          attachment: null,
        },
      };

    case types.UPDATE_VARIATION_REGISTER_NOTE_REQUEST:
      return {
        ...state,
        updateNoteSuccess: false,
      };

    case types.UPDATE_VARIATION_REGISTER_NOTE_SUCCESS:
      return {
        ...state,
        updateNoteSuccess: true,
        notesModal,
      };

    case types.DELETE_VARIATION_REGISTER_NOTE_REQUEST:
      return {
        ...state,
        deleteNoteSuccess: false,
      };

    case types.DELETE_VARIATION_REGISTER_NOTE_SUCCESS:
      return {
        ...state,
        deleteNoteSuccess: true,
        notesModal,
      };

    default: {
      return state;
    }
  }
}

const updateVariationTask = (state, action) => {
  const {
    payload: { taskId, subTaskId, name, value },
  } = action;
  const clonedVariationTasks = copy(state.variationTasks);
  let clonedUpdatedTasks = copy(state.updatedTasks);
  const selectedTask = clonedVariationTasks.find((task) => task.id === taskId);

  if (selectedTask) {
    const selectedSubTask = selectedTask.sub_task.find(
      (subTask) => subTask.id === subTaskId,
    );

    if (selectedSubTask) {
      if (name === 'claim_status') {
        if (!selectedSubTask.claim_approved) {
          selectedSubTask[name] = +value;
        } else if (+value === 2 || +value === 3) {
          selectedSubTask[name] = +value;
        }
      } else {
        selectedSubTask[name] = +value;
      }

      if (clonedUpdatedTasks.find((task) => task.id === subTaskId)) {
        clonedUpdatedTasks = clonedUpdatedTasks.filter(
          (task) => task.id !== subTaskId,
        );
      }

      // if (name === "claim_amount") {
      //   selectedSubTask.claim_amount_change = selectedSubTask.claim_amount;
      // }
      clonedUpdatedTasks.push(selectedSubTask);
    }
  }

  return {
    ...state,
    variationTasks: clonedVariationTasks,
    updatedTasks: clonedUpdatedTasks,
  };
};

const updatePerPage = (state, action) => {
  const clonedPagination = copy(state.pagination);

  clonedPagination.perPage = action.payload;
  if (
    clonedPagination.perPage >= clonedPagination.total ||
    clonedPagination.pageNumber >= clonedPagination.totalPages
  ) {
    clonedPagination.pageNumber = 1;
  }

  return {
    ...state,
    pagination: clonedPagination,
  };
};

const updateClaimStatus = (state, action) => {
  const {
    payload: { status },
  } = action;

  const clonedClaimStatus = copy(claimStatus);

  clonedClaimStatus.forEach((clonedSt) => {
    status.forEach((st) => {
      if (clonedSt.label === st.label && clonedSt.value === st.value) {
        clonedSt.checked = st.checked;
      }
    });
  });
  return {
    ...state,
    claimStatus: clonedClaimStatus,
    updateClaimStatusSuccess: true,
  };
};

const expandRow = (state, action) => {
  const {
    payload: { taskId },
  } = action;

  const clonedExpandedRow = copy(state.expandedRow);

  if (clonedExpandedRow.tasks.find((task) => task.id === taskId)) {
    clonedExpandedRow.tasks = clonedExpandedRow.tasks.filter(
      (task) => task.id !== taskId,
    );
  } else {
    clonedExpandedRow.tasks.push({ id: taskId });
  }

  return {
    ...state,
    expandedRow: clonedExpandedRow,
  };
};

export default variationRegisterReducer;
